export default function DSA_Linked_Lists() {
  return <div>DSA_Linked_Lists Component</div>;
}
